import { Box } from "@mui/material";
import KpiEditTable from "./KpiEditTable";

function ManageKPIs() {
  return (
    <Box
      sx={{
        "& .swal2-container": {
          zIndex: "14000 !important",
        },
      }}
    >
      <KpiEditTable />
    </Box>
  );
}

export default ManageKPIs;
